
import React, { useMemo, useRef, useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { faEdit, faTrash, faInfo, faCircleInfo, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SweetAlert2 from 'react-sweetalert2';

import AsyncSelect from 'react-select/async';
import useUtils from '../../../../utiles/useUtiles';
import Footer from '../../../components/Footer';
import ModalAddNetwork from '../../../components/network/ModalAddNetwork';
import SAlert from '../../shared/SAlert';

const NetworkList: React.FC = () => {

    const [showAddUpdateNetworkModal, setShowAddUpdateNetworkModal] = useState<boolean>( false );
    const [searchParams, setSearchParams] = useState<any>( { searchText: '', csvTypeId: null, withTemplate: '1' } );
    const [networkList, setNetworkList] = useState<any>( { count: 0, rows: [] } );
    const [loading, setLoading] = useState<boolean>( false );
    const [selectedNetwork, setSelectedNetwork] = useState<any | null>( null );
    const [showDeleteAlert, setShowDeleteAlert] = useState<boolean>( false );
    const [pagination, setPagination] = useState<any>( {
        pageIndex: 0,
        pageSize: 10
    } );
    const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    useEffect( () => {
        fetchNetwork();
    }, [pagination.pageIndex, pagination.pageSize] );

   
    const columns = useMemo(
        () => [
          {
            accessorKey: 'csvType',
            header: 'Template Type',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell }: any ) => <span>{cell.getValue()?.name}</span>,
          },
          {
            accessorKey: 'name',
            header: 'Network Name',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell }: any ) => 
            <span>
                {cell.getValue()} &nbsp;
                {
                    cell.row.original['isTemplateCreated'] == 0 && (
                        <FontAwesomeIcon
                            title='Templates not added yet'
                            icon={faInfoCircle}
                            className="text-danger"
                        />
                    ) || ''
                }
            </span>,
          },
          {
            accessorKey: 'status',
            header: 'Status',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell }: any ) => <span>{cell.getValue() == 1 ? 'Active' : 'Inactive'}</span>,
          },
          {
            accessorKey: 'actions',
            header: 'Action',
            minSize: 30,
            maxSize: 60,
            Cell: ( { cell }: any ) => <div>
                <FontAwesomeIcon
                  title='Edit'
                  icon={faEdit}
                  className="isPointer ml-2 cursor-pointer"
                  onClick={() => openEditModal( cell.row.original )}
                />&nbsp;
                {
                    cell.row.original['isTemplateCreated'] == 0 && 
                    <FontAwesomeIcon
                        title='Remove'
                        icon={faTrash}
                        className="isPointer ml-2 text-danger cursor-pointer"
                        onClick={() => confirmDelete( cell.row.original )}
                    /> || ''
                }
                
            </div>,
          }
        ],
        [],
    );

    const openEditModal = ( network: any ) => {
        setSelectedNetwork( network );
        setShowAddUpdateNetworkModal( true );
    };

    const closeModal = () => {
        setShowAddUpdateNetworkModal( false );
        setSelectedNetwork( null );
        fetchNetwork();
    };

    const confirmDelete = ( network: any ) => {
        setSelectedNetwork( network );
        setShowDeleteAlert( true );
    };

    const handleDelete = async () => {
        setLoading( true );
        const request = await axios.delete( `${baseUrl()}/template_type_networks/${selectedNetwork.id}` );
        setLoading( false );
        const { error, result, message } = request.data;
    
        if ( error ) {
            toast.error( message || 'Error to delete the record' );
        } else {
            fetchNetwork();
            setSelectedNetwork( null );
            setShowDeleteAlert( false );
            toast.success( message );
            // setTemplateList(result);
        }
    };

    const csvTypeOptions = ( inputValue: string ): Promise<any[]> => {
        return new Promise<any[]>( async ( resolve ) => {
            const result: any[] = await fetchCsvTypes( inputValue );
            resolve( result );
        } );
    }

    const fetchCsvTypes = ( searchText: string ): Promise<any[]> => {
        return new Promise<any[]>( async ( resolve ) => {
            var query = 'page=0&pageSize=5';
            if ( searchText ) {
              query += `&searchText=${searchText}`;
            }
    
            const request = await axios.get( `${baseUrl()}/template_types?${query}` );
            const { error, result, message } = request.data;
    
            if ( error ) {
                toast.error( message );
                resolve( [] );
            } else {
                const data = result['rows'].map( (r: any) => ( {
                    label: r.name,
                    value: r.id 
                } ) );
                resolve( data );
            }
        } );
    };

    const onSearchChange = ( field: string, value: string | null ) => {
        setSearchParams( {
          ...searchParams,
          [field]: value
        } );
    };

    const fetchNetwork = async () => {
        setLoading( true );
        const searchString = Object.keys( searchParams )
        .filter( key => searchParams[key] )
        .map( key => `${key}=${searchParams[key]}` ).join( '&' );

        const request = await axios.get( `${baseUrl()}/template_type_networks?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&${searchString}` );
        const { error, message, result } = request.data;
        setLoading( false );
        if ( error ) {
            toast.error( message );
        } else {
            setNetworkList( result );
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="main-container">
                          <div className="main-container-inner">
                            {/* <div className="logo mb-3"><img src="logo-min.png" /></div> */}
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>Network List</h1>
                                    <button data-cy="btnAdd" className='btn btn-md btn-custom-secondary' onClick={() => setShowAddUpdateNetworkModal( true )}>
                                        Add
                                    </button>
                                </div>
                                <div className='mb-4 row gap-10'>
                                        <div className='col-md-6'>
                                            <input type={"text"} name="searchText" placeholder="Network name" className="form-control" autoComplete='new-password' onChange={( e ) => onSearchChange( 'searchText', e.target.value )} />
                                        </div>
                                        <div className='col-md-4 select-dropdown'>
                                            <AsyncSelect 
                                                cacheOptions 
                                                isClearable={true}
                                                loadOptions={csvTypeOptions} 
                                                defaultOptions 
                                                name="csvTypeId" 
                                                onChange={selectedOption => {
                                                    if ( selectedOption && selectedOption['value'] ) {
                                                        onSearchChange( 'csvTypeId', selectedOption['value'] );
                                                    } else {
                                                        onSearchChange( 'csvTypeId', null );
                                                    }
                                                }} 
                                            />
                                        </div>
                                        <div className='col-md-1'>
                                            <button type="button" className="btn btn-md btn-custom-secondary" onClick={fetchNetwork}>Search</button>
                                        </div>
                                        <div className="col-md-6">
                                            <select
                                                className="form-control"
                                                aria-label="Default select example"
                                                name="withTemplate" 
                                                onChange={( e ) => onSearchChange( 'withTemplate', e.target.value )}
                                            >
                                                <option value="1">All</option>
                                                <option value="2">Only show network with template</option>
                                                <option value="3">Only show network without template</option>
                                            </select>
                                            {/* <div class="form-check">
                                                <input className="form-check-input" type="checkbox" name="withTemplate" value="1" id="withTemplate" onChange={( e ) => onSearchChange( 'withTemplate', e.target.checked ? '1' : '0' )} />
                                                <label className="form-check-label" for="withTemplate">
                                                    Show networks with template
                                                </label>
                                            </div> */}
                                        </div>                                        
                                </div>
                                <MaterialReactTable 
                                    columns={columns} 
                                    data={networkList?.rows} 
                                    rowCount={networkList?.count} 
                                    enableColumnOrdering={false} 
                                    enableRowSelection={false} 
                                    enableSelectAll={false}
                                    enableColumnActions={false}
                                    manualPagination
                                    onPaginationChange={setPagination}
                                    state={{ pagination }}
                                    enableSorting={false}
                                    enableGlobalFilter={false}
                                    enableFullScreenToggle={false}
                                    enableDensityToggle={false}
                                    enableHiding={false}
                                    enableColumnFilters
                                    enableFilters={false}
                                />
                                <SAlert
                                    show={showDeleteAlert}
                                    showCancel
                                    confirmBtnText="Yes"
                                    cancelBtnText="No"
                                    confirmBtnBsStyle="primary"
                                    cancelBtnBsStyle="secondary"
                                    onCancel={() => setShowDeleteAlert( false )}
                                    title={`Delete Record`}
                                    msg={`Are you sure to delete the network, ${selectedNetwork?.name}?`}
                                    onConfirm={() => handleDelete()}
                                />
                            </div>
                          </div>
                          <Footer />
                        </div>
                    </div>
                </div>
            </div>
            { showAddUpdateNetworkModal && <ModalAddNetwork show={showAddUpdateNetworkModal} handleClose={closeModal} networkDetails={selectedNetwork} />}
            {loadingScreen( loading )}
        </>
    );
}

export default NetworkList